import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-docs-atraves-negocio',
  templateUrl: './modal-docs-atraves-negocio.component.html',
  styleUrls: ['./modal-docs-atraves-negocio.component.scss']
})
export class ModalDocsAtravesNegocioComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalDocsAtravesNegocioComponent>,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  fecharModal(ev) {  
    this.dialogRef.close(ev);
  }

}
